"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = getClient;

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _uaDetect3 = _interopRequireDefault(require("@baidu/mvideo-tool/lib/uaDetect"));

function getClient() {
  var ua = 'other';

  var _uaDetect = (0, _uaDetect3.default)(),
      isHaoKan = _uaDetect.isHaoKan,
      isQuanmin = _uaDetect.isQuanmin,
      isShouBai = _uaDetect.isShouBai,
      isDrama = _uaDetect.isDrama,
      isWeChat = _uaDetect.isWeChat,
      isTieba = _uaDetect.isTieba,
      isBaiduHi = _uaDetect.isBaiduHi;

  var uaList = [{
    key: 'haokan',
    status: isHaoKan
  }, {
    key: 'quanmin',
    status: isQuanmin
  }, {
    key: 'baiduboxapp',
    status: isShouBai
  }, {
    key: 'fanle',
    status: isDrama
  }, {
    key: 'tieba',
    status: isTieba
  }, {
    key: 'infoflow',
    status: isBaiduHi
  }, {
    key: 'weixin',
    status: isWeChat
  }];
  var matchUa = (0, _find.default)(uaList).call(uaList, function (uaItem) {
    return uaItem.status;
  });

  if (matchUa && matchUa.key) {
    ua = matchUa.key;
  }

  return ua;
}